<template>
    <div v-show="visible" class="workspace-alert">
        <div class="message">
            <p>{{ $t('growth.SaveToWorkspace.messageBefore') }}<a :href="url" class="to-workspace-link" target="_blank">{{ message }}</a>{{ $t('growth.SaveToWorkspace.messageAfter') }}</p>
            <svg class="zen-icon-cross-bold" aria-hidden="true" @click="onClose">
                <use xlink:href="#zen-icon-cross-bold" fill="#ffffff" />
            </svg>
        </div>
    </div>
</template>

<script>
import noop from 'lodash/noop';
import template from 'lodash/template';
import { FE_WORKSPACE_URI } from '@/constants';

export default {
    name: 'WorkspaceAlert',
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        onClose: {
            type: Function,
            default: noop,
        },
        count: {
            type: Number,
            default: 0,
        },
        folderName: {
            type: String,
            default: '',
        },
        folderId: {
            type: String,
            default: '',
        },
        spaceId: {
            type: String,
            default: '',
        },
    },
    computed: {
        message() {
            const tplString = this.$t('growth.SaveToWorkspace.toWorkspace');
            const value = {
                folderName: this.folderName,
            };
            return template(tplString)(value);
        },
        url() {
            let spaceId = this.spaceId;
            let folderId = this.folderId;
            return `${FE_WORKSPACE_URI}/detail/patent/folders?spaceId=${spaceId}&folderId=${folderId}&page=1`;
        },
    },
};
</script>

<style lang="scss" scoped>
.workspace-alert {
    color: #ffffff;
    background: #70b364;
    border: 0;
    position: fixed;
    padding: 10px 20px;
    padding-right: 40px;
    z-index: 99999;
    transform: translate(-50%, 0);
    left: 50%;
    top: 0;
    box-shadow: 0 11px 20px #9e9e9e;

    .zen-icon-cross-bold {
        color: #ffffff;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        right: 10px;
        cursor: pointer;
        width: 16px;
        height: 16px;
    }
    .to-workspace-link {
        color: #f8f387;
        text-decoration: underline;
    }
}
</style>
